const cellphone = [
    (v:any) => !!v || 'Informe um telefone',
    (v:any) => v.charAt(5) === "9" || 'Informe um telefone válido',
    (v:any) => v.length === 15 || 'Informe um telefone válido'
]

export default cellphone